export const COLLAPSED_PANEL_WIDTH = "88px";
export const EXPANDED_PANEL_WIDTH = "332px";
export const TRANSITION_TIMEOUT = "0.3s";
